import { createSelector } from 'reselect';

const selectRoutes = (state: any) => state.routes;


export const selectRoutesCurrentItem = createSelector([selectRoutes], (routes) => routes.current);

export const selectRoutesListItems = createSelector([selectRoutes], (routes) => routes.list);

export const selectRoutesItemById = (itemId: any) =>
    createSelector(selectRoutesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRoutesQueryItems = createSelector([selectRoutes], (routes) => routes.query);

export const selectRoutesCreatedItem = createSelector([selectRoutes], (routes) => routes.create);

export const selectRoutesUpdatedItem = createSelector([selectRoutes], (routes) => routes.update);

export const selectRoutesReadItem = createSelector([selectRoutes], (routes) => routes.read);

export const selectRoutesDeletedItem = createSelector([selectRoutes], (routes) => routes.delete);

export const selectRoutesSearchedItems = createSelector([selectRoutes], (routes) => routes.search);

export const selectRoutesItemsCount = createSelector([selectRoutes], (routes) => routes.count);

export const selectRoutesItemsFilter = createSelector([selectRoutes], (routes) => routes.filter);